<template>

<main>
            <!--  Login Background  -->

<div class="container-fluid stepsBar signupContF vld-parent" ref="reg_loading">
	<div class="container pt-5">
		<div class="row textLightGray align-items-center">
			<div class="col-4"><p class="graySemiBoldText mb-0" v-if="step>1" @click="step --">Back</p></div>
			<!-- <div class="col-4"><p class="text-center graySemiBoldText mb-0">Sign Up Information</p></div> -->
			<div class="col-4 text-right">
			<!--
                <p class="text-right graySemiBoldText mb-0" v-if="step<3">{{step}}/2</p>
				<div class="d-flex justify-content-end" v-if="step==3" >
					<button class="btn fillOutLater m-0" @click="skip_step(step)">Fill Out Later...</button>
				</div>
                -->
			</div>
		</div>
	</div>
	<div class="container pb-5">
		<div class="row">
			<div class="col-lg-3">
			</div>
			<div class="col-lg-6 p-0">
				<!-- hide this all -->
			<!-- 	<transition name="fade" mode="in-out"> -->
				<form v-show="step==1" class="userFormWrpr text-left mx-auto my-5 p-5 loginRegSection" autocomplete="off" data-vv-scope="frmStep1" @submit.prevent="next_step('submit')">
					<h2 class="text-center ">Sign Up <strong style="color: #154478;">FREE</strong></h2>
					<p class="text-center textLightGray mb-5">Sign up for <strong style="color: #154478;">FREE</strong> to start shopping at your professional personal showroom</p>
					<label class="inputWrpr" :class="{ 'error': verrors.has('frmStep1.first_name')||verrors.has('first_name')||verrors.has('frmStep1.last_name')||verrors.has('last_name'), 'haveValue': details.full_name }" >
						<input type="text" name="first_name" class="form-control" v-model="details.full_name" v-validate="'required'" data-vv-as="first and last name">
						<span class="label">First and Last Name</span>
						<p class="errormsg" v-if="verrors.has('frmStep1.first_name')||verrors.has('first_name')||verrors.has('frmStep1.last_name')||verrors.has('last_name')">
                            {{ verrors.first('frmStep1.first_name')||verrors.first('first_name')||verrors.first('frmStep1.last_name')||verrors.first('last_name') }}
						</p>
					</label>
<!-- 					<label class="inputWrpr" :class="{ 'error': verrors.has('frmStep1.last_name')||verrors.has('last_name'),'haveValue': details.last_name }">
						<input type="text" name="last_name" class="form-control"  v-model="details.last_name" v-validate="'required'" data-vv-as="Last name">
						<span class="label">Last Name</span>
						<p class="errormsg" v-if="verrors.has('frmStep1.last_name')||verrors.has('last_name')">
                            {{ verrors.first('frmStep1.last_name')||verrors.first('last_name') }}
						</p>
					</label> -->
					<label class="inputWrpr" :class="{ 'error': verrors.has('frmStep1.email')||verrors.has('email'),'haveValue': details.email }">
						<input type="email" name="email" class="form-control" v-model="details.email" v-validate="'required|email'" data-vv-as="Email">
						<span class="label">Email</span>
						<p class="errormsg" v-if="verrors.has('frmStep1.email')||verrors.has('email')">
                            {{ verrors.first('frmStep1.email')||verrors.first('email') }}
						</p>
					</label>
					<label class="inputWrpr" :class="{ 'error': verrors.has('frmStep1.password')||verrors.has('password'),'haveValue': details.password }">
						<input :type="showPassword?'text':'password'" name="password" class="form-control" v-model="details.password" v-validate="'required|min:8'" data-vv-as="password">
						<span class="label">Password</span>

				<div class="control">
					<button type="button" class="button" @click="showPassword=!showPassword">
						<span class="icon is-small is-right">
							<i class="fa" :class="{ 'fa-eye-slash': showPassword, 'fa-eye': !showPassword }"></i>
						</span>
					</button>
				</div>


						<p class="errormsg" v-if="verrors.has('frmStep1.password')||verrors.has('password')">
                            {{ verrors.first('frmStep1.password')||verrors.first('password') }}
						</p>
					</label>
					<div class="form-group">
						<div class="row">
							<div class="col-3">
								<label class="inputWrpr" :class="{ 'error': verrors.has('frmStep1.country_code')||verrors.has('country_code'),'haveValue': details.country_code }">
									 <div class="form-control select">{{details.country_code}}</div>
                                <span class="label w-100"></span>

                                <div class="selectDropDown">
                                    <CountryList  v-validate="'required'" data-vv-as="country code" name="country_code" v-model="details.country_code"/>
                                </div>
                                <p class="errormsg"
                                    v-if="verrors.has('frmStep1.country_code')||verrors.has('country_code')">
                                    {{ verrors.first('frmStep1.country_code')||verrors.first('country_code') }}
                                </p>
								</label>
							</div>
							<div class="col-9">
								<label class="inputWrpr" :class="{ 'error':verrors.has('frmStep1.phone_number')||verrors.has('phone_number'), 'haveValue': details.phone_number }">
									<input  type="text"
									class="form-control"
									:class="{ 'error': errors.phone_number }"
									id="phone_number"
									v-model="details.phone_number" name="phone_number" v-validate="'required'" data-vv-as="phone number"/>
									<span class="label">Phone Number</span>
                                    <p class="errormsg"
                                    v-if="verrors.has('frmStep1.phone_number')||verrors.has('phone_number')">
                                    {{ verrors.first('frmStep1.phone_number')||verrors.first('phone_number') }}
                                </p>
								</label>
							</div>
						</div>

					</div>
			<label class="inputWrpr"
			    :class="{ 'error': verrors.has('frmStep1.zip_code')||verrors.has('zip_code'),'haveValue': details.zip_code }">
			    <input type="text" name="zip_code" class="form-control" v-model="details.zip_code" v-validate="'required'"
			        data-vv-as="Zip Code">
			    <span class="label">Zip Code</span>
			    <p class="errormsg" v-if="verrors.has('frmStep1.zip_code')||verrors.has('zip_code')">
			        {{ verrors.first('frmStep1.zip_code')||verrors.first('zip_code') }}
			    </p>
			</label>


                    <!-- <div class="form-group form-check">
                        <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="details.i_accept" v-validate="'required'" data-vv-as="agree" name="i_accept">
                        <label class="form-check-label" for="exampleCheck1">I Accept Wevisu <a href="javascript:void(0);" data-toggle="modal" data-target="#terms_modal">terms and condition</a>  </label>
						<p class="errormsg"
							v-if="verrors.has('frmStep1.i_accept')||verrors.has('i_accept')">
							{{ verrors.first('frmStep1.i_accept')||verrors.first('i_accept') }}
						</p>
                    </div> -->


                    
                    <label class="d-inline-flex">
                        <span class="me-2">
                            <input type="checkbox" v-model="details.agree" v-validate="'required'" name="agree" data-vv-as="Terms of Service"> 
                        </span>
                        <span>
                            I have read and agree to WeVisu <a style="cursor: pointer; text-decoration: underline;" data-toggle="modal" data-target="#termsModal_1">Terms of Use</a> and <a style="cursor: pointer;  text-decoration: underline;" data-toggle="modal" data-target="#termsModal_3">Privacy Policy</a>
                        </span>
                    </label>
                    <p class="errormsg" v-if="verrors.has('frmStep1.agree')||verrors.has('agree')">{{ verrors.first('frmStep1.agree')||verrors.first('agree') }}</p>
                    <!-- <br>
                    <input type="checkbox" v-model="details.agree_pp" v-validate="'required'" name="agree_pp" data-vv-as="Privacy Policy">
                    <label>I have read and agree with the <a style="cursor: pointer;  text-decoration: underline;" data-toggle="modal" data-target="#termsModal_3">Privacy Policy</a>
                    </label>
                    <p class="errormsg" v-if="verrors.has('frmStep1.agree_pp')||verrors.has('agree_pp')">{{ verrors.first('frmStep1.agree_pp')||verrors.first('agree_pp') }}</p> -->






					<div class="form-group text-center mt-4">
						<button type="submit"  class="btn btnSubmit">Done</button>
					</div>
					<div class="form-group text-center">
						<router-link to="/login" class="btnForget">Sign In</router-link>
					</div>
                    <div class="form-group text-center mt-4">
                        <router-link
                                to="/" 
                                class="btnForget">Continue Shopping
                            </router-link>
                    </div>
				</form>
				<!-- hide this all -->
				<form v-show="step==2" class="userFormWrpr text-left mx-auto my-5" autocomplete="off" data-vv-scope="frmStep2" @submit.prevent="next_step('submit')">
					<h2 class="text-center ">Shipping Address</h2>
					<p class="text-center textLightGray mb-5">Hi there, just a few quick steps and your in</p>
					<label class="inputWrpr" :class="{ 'error': verrors.has('frmStep2.shipping_street')||verrors.has('shipping_street'),'haveValue': details.shipping_street }">
						<input type="text" class="form-control" v-model="details.shipping_street" v-validate="'required'" data-vv-as="shipping street" name="shipping_street">
						<span class="label">Street</span>
						<p class="errormsg" v-if="verrors.has('frmStep2.shipping_street')||verrors.has('shipping_street')">
							 {{ verrors.first('frmStep2.shipping_street')||verrors.first('shipping_street') }}
						</p>
					</label>
					<label class="inputWrpr" :class="{ 'error': verrors.has('frmStep2.shipping_city')||verrors.has('shipping_city'),'haveValue': details.shipping_city }">
						<input type="text" class="form-control" v-model="details.shipping_city" v-validate="'required'" data-vv-as="shipping city" name="shipping_city">
						<span class="label">City</span>
						<p class="errormsg" v-if="verrors.has('frmStep2.shipping_city')||verrors.has('shipping_city')">
							{{ verrors.first('frmStep2.shipping_city')||verrors.first('shipping_city') }}
						</p>
					</label>
					<label class="inputWrpr" :class="{ 'error': verrors.has('frmStep2.shipping_state')||verrors.has('shipping_state') ,'haveValue': details.shipping_state}">
						<input type="text" v-model="details.shipping_state" class="form-control" v-validate="'required'" data-vv-as="shipping state" name="shipping_state">
						<span class="label">State</span>
						<p class="errormsg" v-if="verrors.has('frmStep2.shipping_state')||verrors.has('shipping_state')">
							{{ verrors.first('frmStep2.shipping_state')||verrors.first('shipping_state') }}
						</p>
					</label>
					<label class="inputWrpr" :class="{ 'error': verrors.has('frmStep2.shipping_zip_code')||verrors.has('shipping_zip_code'),'haveValue': details.shipping_zip_code }">
						<input type="text" v-model="details.shipping_zip_code" class="form-control" v-validate="'required'" data-vv-as="shipping Zip Code" name="shipping_zip_code">
						<span class="label">Zip Code</span>
						<p class="errormsg" v-if="verrors.has('frmStep2.shipping_zip_code')||verrors.has('shipping_zip_code')">
							{{ verrors.first('frmStep2.shipping_zip_code')||verrors.first('shipping_zip_code') }}
						</p>
					</label>
					<label class="inputWrpr" :class="{ 'error': errors.shipping_apartment,'haveValue': details.shipping_apartment }">
						<input type="text" v-model="details.shipping_apartment" class="form-control">
						<span class="label">Apartment</span>
						<p class="errormsg" v-if="errors.shipping_apartment">
							{{ errors.shipping_apartment[0] }}
						</p>
					</label>
					<div class="form-group text-center mt-4">
						<button type="submit" class="btn btnSubmit" >Done</button>
					</div>
					<div class="form-group text-center">
						<router-link to="/login" class="btnForget">Sign In</router-link>
					</div>
				</form>
				<!-- hide this all -->
				<form v-show="step==3" class="userFormWrpr text-left mx-auto my-5" autocomplete="off" data-vv-scope="frmStep3">

					<h2 class="text-center ">Payment Information</h2>
					<p class="text-center textLightGray mb-5">Fill out payment details for easier online ordering</p>
					<label class="inputWrpr" :class="{ 'error': errors.card_number || cardErrors.cardNumber,'haveValue': details.card_number }">
						<input  v-model="details.card_number" class="form-control" v-cardformat:formatCardNumber placeholder="#### #### #### ####">
						<span class="label">Card Number</span>
						<span class="icons">
						<i :class="cardBrandClass" v-if="cardBrandClass"></i>
						<img v-else src="images/card.png" class="img-fluid" alt="">
						</span>
						<p class="errormsg" v-if="errors.card_number||cardErrors.cardNumber">
							{{ typeof cardErrors.cardNumber  == 'undefined' ? errors.card_number[0] : cardErrors.cardNumber }}
						</p>
					</label>
					<label class="inputWrpr" :class="{ 'error': errors.name_on_Card ,'haveValue': details.name_on_Card}">
						<input type="text" ref="cardNameInput" v-model="details.name_on_Card" class="form-control">
						<span class="label">Name on Card</span>
						<p class="errormsg" v-if="errors.name_on_Card">
							{{ errors.name_on_Card[0] }}
						</p>
					</label>
					<div class="form-group">
						<div class="row">
							<div class="col-6">
								<label class="inputWrpr" :class="{ 'error': errors.exp_date || cardErrors.cardExpiry ,'haveValue': details.exp_date}">
									<input placeholder="MM/YY" v-model="details.exp_date" class="form-control" v-cardformat:formatCardExpiry>
									<span class="label">Expiration Date</span>
									<p class="errormsg" v-if="errors.exp_date || cardErrors.cardExpiry">
										{{ typeof cardErrors.cardExpiry  == 'undefined' ? errors.exp_date[0] : cardErrors.cardExpiry }}
									</p>
								</label>
							</div>
							<div class="col-6">
								<label class="inputWrpr" :class="{ 'error': errors.cvv || cardErrors.cardCvc,'haveValue': details.cvv }">
									<input ref="cardCvvInput" v-model="details.cvv" class="form-control" v-cardformat:formatCardCVC>
									<span class="label">CVV Code</span>
									<span class="icons help" v-tooltip="'it\'s the 3-digit number on the back of the card'"><img src="images/help.png" class="img-fluid" alt=""></span>
									<p class="errormsg" v-if="errors.cvv">
										{{ typeof cardErrors.cardCvc  == 'undefined' ?  errors.cvv[0] : cardErrors.cardCvc}}
									</p>
								</label>
							</div>
						</div>
					</div>
					<div class="form-group">
						<div class="row">
							<div class="col-6">
								<label class="inputWrpr" :class="{ 'error': errors.pay_street ,'haveValue': details.pay_street}">
									<input type="text" v-model="details.pay_street" class="form-control">
									<span class="label">Street</span>
									<p class="errormsg" v-if="errors.pay_street">
										{{ errors.pay_street[0] }}
									</p>
								</label>
							</div>
							<div class="col-6">
								<label class="inputWrpr"
									:class="{ 'error': errors.pay_state ,'haveValue': details.pay_state}">
									<input  type="text" v-model="details.pay_state"  class="form-control">
									<span class="label">State</span>
									<p class="errormsg" v-if="errors.pay_state">
										{{ errors.pay_state[0] }}
									</p>
								</label>
							</div>
						</div>
					</div>
					<div class="form-group">
						<div class="row">
							<div class="col-6">
								<label class="inputWrpr"
									:class="{ 'error': errors.pay_city ,'haveValue': details.pay_city}">
									<input  type="text" v-model="details.pay_city"  class="form-control">
									<span class="label">City</span>
									<p class="errormsg" v-if="errors.pay_city">
										{{ errors.pay_city[0] }}
									</p>
								</label>
							</div>
							<div class="col-6">
								<label class="inputWrpr"
									:class="{ 'error': errors.pay_zip_code ,'haveValue': details.pay_zip_code}">
									<input  type="text" v-model="details.pay_zip_code"  class="form-control">
									<span class="label">Zip Code</span>
									<p class="errormsg" v-if="errors.pay_zip_code">
										{{ errors.pay_zip_code[0] }}
									</p>
								</label>
							</div>
						</div>
					</div>
					<div class="form-group text-center mt-4">
						<input type="button" value="Done" @click="register" class="btn btnSubmit" />
					</div>
					<div class="form-group text-center">
						<router-link to="/login" class="btnForget">Sign In</router-link>
					</div>
				</form>
				<!-- </transition> -->
			</div>
			<div class="col-lg-3">
			</div>
		</div>
	</div>
</div>




<!-- Modal -->
<div class="modal fade" id="terms_modal" tabindex="-1" role="dialog" aria-labelledby="terms_modalTitle" aria-hidden="true">
  <div class="modal-dialog  modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="terms_modalTitle">Terms and Condition</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
       <TermsPage/>
        <div class="form-group form-check">
            <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="details.i_accept"
                v-validate="'required'" data-vv-as="agree" name="i_accept">
            <label class="form-check-label" for="exampleCheck1">I Accept Wevisu terms and condition</label>

        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>



<!-- Modal Terms of Service -->
        <div class="modal fade" id="termsModal_1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog  modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h3 class="modal-title" id="exampleModalLabel">Terms of Service</h3>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <p>WeVisu offers an auto renewal feature (the “Auto Subscription Program” or “Program”). By agreeing to these terms and conditions you agree to auto enrollment in WeVisu’s Program. All plans and products automatically renew unless you cancel.  You may cancel at any time. The Program hereby incorporates by reference the terms and conditions set forth in WeVisu’s <a style="color: #154478; cursor: pointer;" data-toggle="modal" data-target="#termsModal_2">terms and procedures policies</a>. The renewal will be for the same term length and at the regular rates reflected in your Control Panel. The payment method you have provided today, will be used for all renewals unless you change it or cancel.  You may cancel at any time by simply emailing <a href="mailto:support@wevisu.com">support@wevisu.com</a>. Please provide your full name, email address associated with your account, and your wish to cancel. </p>
                <p>By clicking below you hereby affirm that you have read and agree to WeVisu’s Auto Subscription Program, Terms of Service and Cancellation Policy and acknowledge receipt of the <a style="color: #154478; cursor: pointer;" data-toggle="modal" data-target="#termsModal_3">Privacy Policy</a>. </p>
              </div>
              <div class="modal-footer">
                <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary">Save changes</button> -->
              </div>
            </div>
          </div>
        </div>
        <!-- ending modal -->

        <!-- Modal Terms of Service Page-->
        <div class="modal fade" id="termsModal_2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <termspage></termspage>
              </div>
              <div class="modal-footer">
                <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary">Save changes</button> -->
              </div>
            </div>
          </div>
        </div>
        <!-- ending modal -->

        <!-- Modal Terms of Service Page-->
        <div class="modal fade" id="termsModal_3" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <privacypage></privacypage>
              </div>
              <div class="modal-footer">
                <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary">Save changes</button> -->
              </div>
            </div>
          </div>
        </div>
        <!-- ending modal -->

       <!-- modal -->
       <div class="modal fade withBottomIcon" id="signupalert" tabindex="-1" role="dialog"
            aria-labelledby="signupalertTitle" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header p-0">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body py-5 text-center">
                        <h3 class="mb-4">Thank you for signing up for WeVisu!</h3>
                        
                        <router-link class="btnSucces mb-4" to="/" > Return to home page</router-link>
                    </div>
                </div>
            </div>
        </div>
        <!-- ending modal -->

</main>
</template>

<script>
import Vue from 'vue'
//import BaseService from '../services/BaseService';
	import privacypage from '../../pages/Privacy_policy.vue'
	import termspage from '../../pages/Terms_conditions.vue'
import { EventBus } from '../../store/eventBus';
 import CountryList from '../Country-list.vue'
 import {
     mapGetters,
     mapActions
 } from "vuex";
 export default {
     name: 'Registration',
     components: {
         CountryList,
         termspage,
        	privacypage,
         TermsPage: () =>import('../../pages/Terms_conditions.vue')

     },
     data() {
         return {
			 showPassword: false,
             step: 1,
             details: {
                full_name:'',
                 type: 'User',
                 password:'',
                 country_code: '+1',
                 exp_date: '',
                 card_number: '',
                 cvv: ''
             },

             cardErrors: {},
             // declaring card-brand in data{} enables card brand name/classes.
             cardBrand: null,
             // demo only
             $cardFormat: Vue.prototype.$cardFormat
         }
     },
     watch: {
                  user: {
             handler: function (newValue) {
                 if (newValue) {
                     if (this.user) {
                         this.$router.push("/account").catch(() => {});;
                     }
                 }
             },
             deep: true
         },
         async errors(n) {
             if (n.card_number || n.name_on_Card || n.exp_date || n.cvv || n.pay_street) {
                 this.step = 3;
             }
             if (n.shipping_street || n.shipping_city || n.shipping_state || n.shipping_zip_code) {
                 this.step = 2;
             }
             if (n.first_name || n.last_name || n.email || n.password || n.county_code || n.phone_number) {
                 this.step = 1;
             }
			 this.scrollup();
         },
         'details.card_number': function (val) {
             if (this.$cardFormat.validateCardNumber(val)) {
                 this.$refs.cardNameInput.focus();
             }
         },
         'details.exp_date': function (val) {
             if (this.$cardFormat.validateCardExpiry(val)) {
                 this.$refs.cardCvvInput.focus();
             }
         }


     },
     computed: {
        ...mapGetters(["errors"]),
        ...mapGetters("auth", ["user"]),
        cardBrandClass() {
            return this.getBrandClass(this.cardBrand);
        },
        ...mapGetters({
            showroomId: "Common/MyItem",
        })
     },

     mounted() {
         this.$store.commit("setErrors", {});
         if (this.user) {
             this.$router.push('/').catch(() => {});;
         }
     },

     methods: {
        ...mapActions("auth", ["sendRegisterRequest"]),
        ...mapActions("cart", ["projectCreatRequest","addProjectToCartRequest"]),
        async next_step(final = false) {
            this.$validator.validateAll('frmStep' + this.step).then(async (valid) => {
                if (valid) {
                    this.step++
                    if (final == 'submit') {
                        this.step = 1;
                        this.register();
                    }
                }
            })
        },

        onCountryChange(value) {
             this.details.country_code = value;
         },
		skip_step(step){
			this.cardErrors = {};
			this.details.card_number=''
			this.details.name_on_Card=''
			this.details.exp_date=''
			this.details.cvv=''
			this.details.pay_street=''
			this.details.pay_state=''
			this.details.pay_city=''
			this.details.pay_zip_code=''
			 this.register();
		 },
         register: function () {
             this.cardErrors = {};

             // validate card number
             if (!this.$cardFormat.validateCardNumber(this.details.card_number) && this.details.card_number) {
                 this.cardErrors.cardNumber = "Invalid Card Number.";
             };

             // validate card expiry
             if (!this.$cardFormat.validateCardExpiry(this.details.exp_date) && this.details.exp_date) {
                 this.cardErrors.cardExpiry = "Invalid Expiration Date.";
             };

             // validate card CVC
             if (!this.$cardFormat.validateCardCVC(this.details.cvv) && this.details.cvv) {
                 this.cardErrors.cardCvc = "Invalid CVC.";
             };

             if (Object.keys(this.cardErrors).length==0) {
                let loader = this.$loading.show({
                        container: this.$refs.reg_loading,
                    });

                    this.details.first_name = this.details.full_name.split(' ').slice(0, 1).join(' ');
                    this.details.last_name = this.details.full_name.split(' ').slice(1).join(' ');

                this.sendRegisterRequest(this.details).then(() => {
                     loader.hide();
                     let visual_redirect = localStorage.getItem('visual_redirect');

                     //cart
                     let temp_project_id=localStorage.getItem('cart_id');

                            if(temp_project_id){

                                var retrievedItem = JSON.parse(localStorage.getItem('my_item'));

                                // let showroom = retrievedItem.showroom
                                let cart_item={};
                                cart_item.re_temp_project_id=temp_project_id;
                                // if (!is_3d) {
                                    this.projectCreatRequest(retrievedItem).then((res) => {
                                        console.log("res====>",res);
                                        var project = parseInt(localStorage.getItem('project'));
                                        console.log("project==========>",project);
                                        if(project){
                                            cart_item.project_id = project
                                        }else{
                                            cart_item.project_id =res;
                                        }
                                        let items = []
                                        this.addProjectToCartRequest(cart_item).then(() => {
                                            console.log("event firing for cart-updated");
                                            localStorage.removeItem('cart_id');
                                            EventBus.$emit('cart-updated');
                                            // loader.hide();
                                            // this.$router.push(this.redirect_path || '/').catch(() => {});

                                    })
                                    .catch(() => {
                                        loader.hide();
                                    })


                                        })
                                        .catch(err => {
                                            Toast.fire({
                                                icon: 'error',
                                                title: 'Please login to proceed.'
                                            });
                                        });
                                // }



                            }
                     // cart end
                    $('#signupalert').modal('show');

                     if (this.user && this.user.type == 'User' && visual_redirect) {
                                        var retrievedItem = JSON.parse(localStorage.getItem('my_item'));
                                        if (retrievedItem && retrievedItem.showroom && retrievedItem.floorplan && retrievedItem.floorTemplate) {
                                        var project = localStorage.getItem('project');
                                        if(typeof(project) == 'undefined' || project=='undefined' || project==null || project=='null'){
                                            project=''
                                        }
                                        retrievedItem.project=project
                                        this.projectCreatRequest(retrievedItem).then((res) => {
                                            localStorage.removeItem("visual_redirect");
                                            // let cart_item={};
                                            // cart_item.re_temp_project_id=temp_project_id;
                                            // var project = parseInt(localStorage.getItem('project'));

                                            // console.log("project==========>",project);
                                            // if(project){
                                            //     cart_item.project_id = project
                                            // }else{
                                            //     cart_item.project_id =res;
                                            // }
                                            // this.addProjectToCartRequest(cart_item).then(() => {

                                            //     localStorage.removeItem('cart_id');
                                            //     loader.hide();
                                            //     this.$router.push(this.redirect_path || '/').catch(() => {});

                                            // })
                                            // .catch(() => {
                                            //     loader.hide();
                                            // })
                                            this.$router.push(visual_redirect || '/').catch(() => {});
                                        })
                                        .catch(err=>{
                                            Toast.fire({
                                                icon: 'error',
                                                title: 'Internal server error.'
                                            });
                                            this.$router.push('/visualize').catch(() => {});
                                        });
                                        }else{
                                            this.$router.push('/visualize').catch(() => {});
                                        }
                     } else {
                        var redirect_to = localStorage.getItem('redirect_to');
                        if(redirect_to){
                            localStorage.removeItem('redirect_to');
                            this.$router.push(redirect_to).catch(() => {});
                        }else{
                         this.$router.push("/").catch(() => {});
                        }
                     }
                 }).catch((err) => {
                    console.log(err);
                     loader.hide();
                     if (typeof err.response.data != 'undefined') {
                         this.$setErrorsFromResponse(err.response.data);
                         //pop_loader.hide()
                     }
                 });
             } else {
                 this.step = 3;
				 this.scrollup();
             }

         },
         prefill: function (ccNum) {
             this.details.card_number = ccNum;
             this.$cardFormat.setCardType({
                 currentTarget: this.$refs.cardNumInput,
                 value: ccNum
             });
         },
         getBrandClass: function (brand) {
             let icon = '';
             brand = brand || 'unknown';
             let cardBrandToClass = {
                 'visa': 'fa fa-cc-visa',
                 'mastercard': 'fa fa-cc-mastercard',
                 'amex': 'fa fa-cc-amex',
                 'discover': 'fa fa-cc-discover',
                 'diners': 'fa fa-cc-diners-club',
                 'jcb': 'fa fa-cc-jcb',
                 'unknown': 'fa fa-credit-card',
             };
             if (cardBrandToClass[brand]) {
                 icon = cardBrandToClass[brand];
             };

             return icon;
         }

     }
 };

</script>
<style>
	#termsModal_2 .stepsBar{
        padding-top: 0 !important;
    }
    #termsModal_3 .stepsBar{
        padding-top: 0 !important;
    }

    #termsModal_2 .modal-header, #termsModal_3 .modal-header{
        border: none !important;
    }
</style>
